import { ElementType, FC, ReactNode } from 'react';
import clsx from 'clsx';
import { AText } from '../AText';

import styles from './index.module.css';

type ATextSize = 's' | 'l' | '2xs' | 'xs' | 'm' | 'xl' | '2xl' | '3xl' | '4xl';
type ATextBreed = 'B' | 'R' | 'RU' | 'BU';

interface LinkProps {
  children?: ReactNode;
  Component: ElementType;
  to: string;
  intent?: 'primary' | 'secondary';
  className?: string;
  target?: string;
  color?: string;
  breed?: ATextBreed;
  size?: ATextSize;
}

const intents = {
  primary: {
    breed: 'B' as ATextBreed,
    size: 'l' as ATextSize
  },
  secondary: {
    breed: 'R' as ATextBreed,
    size: 's' as ATextSize
  }
};

export const Link: FC<LinkProps> = ({
  children = '',
  Component,
  to,
  intent = 'primary',
  className = '',
  target = '',
  ...props
}) => (
  <Component to={to} target={target}>
    <AText
      {...intents[intent]}
      className={clsx(styles.general, styles[intent], className)}
      {...props}
    >
      {children}
    </AText>
  </Component>
);
